module.exports = __webpack_public_path__ + "static/media/kisan_eng.a781d90a.png";